import memoizeOne from 'memoize-one';

const BASE_TEN_RADIX = 10;

const parseInteger = (number, radix = BASE_TEN_RADIX) => parseInt(number, radix);

export default memoizeOne(parseInteger);
